// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3k0_o","signatureButtonsRight":"ModalSign_signatureButtonsRight__2L_TY"};